import React from 'react'
import { getDocumentHead } from 'components/DocumentHead'
import Schools from 'components/Organization/Industries/Schools'

export default function ContentFilteringSchoolPage(): React.ReactElement {
  return <Schools />
}

export const Head = getDocumentHead({
  title: 'Secure & Compliant Web Filtering for Schools',
  description: `Ensure safe, distraction-free learning with Control D's
   web filtering for schools. Block threats, control internet access, and protect student privacy.`,
})
